import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import * as Yup from 'yup'
import {Col, Modal, Row, Stack} from 'react-bootstrap'
import {defaultAgentEnrollment, IAgentEnrollmentData, fieldTouched} from './InterfaceAgentModal'
import {geocodeByAddress, getLatLng} from 'react-places-autocomplete'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import {KTSVG} from '../../../../_metronic/helpers'
import {CustomerInfo} from './steps/CustomerInfo'
import {ProductInfo} from './steps/ProductInfo'
import {FormikValues, useFormik} from 'formik'
import Arrow from '../../../../_metronic/images/arr002.svg'
import SVG from 'react-inlinesvg'
import _ from 'lodash'
import {
  CREATE_CUSTOMER_ENROLLMENT,
  UPDATE_CUSTOMER_ENROLLMENT,
  GET_CUSTOMER_BY_UAN_OR_PHONENUMBER,
  GET_CUSTOMER_ENROLLMENT_BY_ID,
  GET_PRODUCT_INFO,
  VALIDATE_CUSTOMER_INFO,
  GET_CUSTOMER_FEATURE_FLAGS,
  TRACK_IMAGE_UPLOADED,
  GET_CIPHER_MESSAGE,
  GET_CIPHER_EMAIL,
  S3_FILE_DELETE,
  CHECK_PHONE_NUMBER_OPTIN,
  CHECK_EXISTING_CUSTOMERR_FOR_SYMMETRY,
  CHECK_EXISTING_CUSTOMERR_FOR_PTM,
  GET_PRODUCT_LANAGUAGE_BENEFIT_PROGRAM,
  GET_CLIENT_ALLOWED_COMPONENTS,
  GET_LINE_TYPE_INTELLIGENCE,
  GET_AGENT_PRODUCTS_AND_FILTER,
  GET_UTILITIES_BY_ZIPCODE,
  GET_CUSTOMER_ENROLLMENT_DATA,
} from '../../../../utils/GraphQLAPI'

import {useLazyQuery, useMutation} from '@apollo/client'
import successIcon from '../../../../_metronic/images/successIcon.svg'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import TPVStatus from './steps/TPVStatus'
import {
  areYouSurePrompt,
  renderPhoneNumber,
  alert,
  toaster,
  showAlertWithCallbackOnConfirmation,
  uploadFiles,
} from '../../../../utils/helper'
import Viewer from '../../../sharedComponent/viewer'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import './CreateAgentModal.css'
import AccountInfo from './steps/AccountInfo'
import {SERVER_URL} from '../../../../utils/config'
import uuid from 'react-uuid'
import AgentGeolocation from './AgentGeoLocation'
import {useMediaQuery} from 'react-responsive'
import {UploadFiles} from '../../../sharedComponent/UploadFiles'

import moment from 'moment'
const MySwal = withReactContent(Swal)

type Props = {
  show: boolean
  handleClose: () => void
  refetchList: () => void
  method: string
  editId: any
  modalConfig: any
  getSalesAdminDashboardData: any
  featureFlags: any
  customerBillImage: any
  enableCustomerBillImage: any
}

const SpecialCharMsg = 'Special characters are not allowed'
const NumMsg = 'Numbers are not allowed'
const EmailMsg = 'Email ID not Valid'
const PhoneNumMsg = 'Phone number is less than 10 digits'
const mobileNumMsg = 'Mobile number is less than 10 digits'
const InvalidNumMsg = 'Invalid Phone Number'
const InvalidMobileNumMsg = 'Invalid Mobile Number'
const AddressMsg = 'Address is required'
const AddressExceedMsg = "Address shouldn't exceed 230 characters"
const StateMsg = 'State is required'
const CityMsg = 'City is required'
const CityNameMsg = 'Enter a valid city name'
const CityMinimumValidation = "City shouldn't be less than 3 characters"
const CityExceedMsg = "City shouldn't exceed 40 characters"
const ZipMsg = 'Zip code is required'
const ZipCodeMsg = 'Enter a valid zip code'
const EmailMinimumValidation = "Email ID shouldn't be less than 10 characters"
const EmailMaximumValidation = "Email ID shouldn't exceed 40 characters"
const modalsRoot = document.getElementById('root-modals') || document.body

const CreateAgentModal = ({
  show,
  handleClose,
  refetchList,
  method,
  editId,
  modalConfig,
  getSalesAdminDashboardData,
  featureFlags,
  customerBillImage,
  enableCustomerBillImage,
}: Props) => {
  const stepperRef = useRef<any>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [products, setProducts] = useState<any>()
  const [locationEnabled, setLocationEnabled] = useState(false)
  const [data, setData] = useState<any>(defaultAgentEnrollment)
  const [hasError, setHasError] = useState(false)
  const [productDetails, setProductDetails] = useState<any>({})
  const [hasFieldError, setHasFieldError] = useState(false)
  const [isCommercialCustomer, setIsCommercialCustomer] = useState<any>(false)
  const [isExistingCustomer, setIsExistingCustomer] = useState<any>(false)
  const [isServiceSameAsBill, setIsServiceSameAsBill] = useState<any>(false)
  const [searchText, setSearchText] = useState('')
  const [customer, setCustomer] = useState('')
  const [documentDelivery, setDocumentDelivery] = useState<string>('MAIL')
  const [sendContract, setSendContract] = useState<boolean>(() => false)
  const [sendContractEmail, setSendContractEmail] = useState<boolean>(() => false)
  const [sendContractMessgae, setSendContractMessage] = useState<any>('')
  const [validationSchema, setValidationSchema] = useState<any>()
  const [currentScreen, setCurrentScreen] = useState(1)
  const [tpvMethods, setTpvMethods] = useState<any>([])
  const [agentCoords, setAgentCoords] = useState<any>(null)
  const [isMixmatch, setIsMixmatch] = useState(false)
  const [isEnableContractStartDate, setIsEnableContractStartDate] = useState(false)
  const [isUtilityMeterNumberRequired, setIsUtilityMeterNumberRequired] = useState(false)
  const [enableContractRequired, setEnableContractRequired] = useState<boolean>(false)
  const [disableExistingCustomerEnrollment, setDisableExistingCustomerEnrollment] = useState(false)
  const [utilities, setUtilities] = useState<any>()
  const [uploadedFiles, setUploadedFiles] = useState<File[]>(() => [])
  const [imageUploadRequired, setImageUploadRequired] = useState<any>(false)
  const [imageTextError, setImageTextError] = useState<any>(false)
  const [forceCameraOpen, setForceCameraOpen] = useState<any>(false)
  const [isSolarProduct, setIsSolarPRoduct] = useState<any>(false)

  const [clientDialInNumber, setClientDialInNumber] = useState('')
  const [isOptedIn, setIsOptedIn] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [FileUploaderror, setFileUploadError] = useState<string | null>(null)
  const [limitValue, setLimitValue] = useState({
    rateMax: 0,
    rateMin: 0,
    termMax: 0,
    termMin: 0,
    grateMax: 0,
    grateMin: 0,
    gtermMax: 0,
    gtermMin: 0,
  })

  const checkLocationEnabled = () => {
    if (navigator.geolocation && (sendContract || sendContractEmail)) {
      navigator.geolocation.getCurrentPosition(
        () => {
          setLocationEnabled(true)
        },
        (error) => {
          setLocationEnabled(false)
          MySwal.fire({
            icon: 'warning',
            title: 'Location Services Disabled',
            text: 'Please turn on location services to continue.',
          })
        }
      )
    } else {
      setLocationEnabled(false)
      MySwal.fire({
        icon: 'error',
        title: 'Geolocation Not Supported',
        text: 'Your browser does not support geolocation.',
      })
    }
  }

  useEffect(() => {
    if (locationEnabled) {
      MySwal.close()
    }
  }, [locationEnabled])
  //Validate zipcode against state in agent screen address.
  const validateZipCodeField = async (values: any) => {
    const errors: {[key: string]: string} = {}

    // ZIP code format regex
    const zipCodeRegex = /^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/

    // Function to validate a single ZIP and state pair
    const validateZipWithState = async (zipCode: string, state: string, zipFieldName: string) => {
      if (!zipCode || !state) return // Skip if fields are empty

      // Check if ZIP code matches the format
      if (!zipCodeRegex.test(zipCode)) {
        errors[zipFieldName] = ZipCodeMsg
        return
      }

      try {
        const results = await geocodeByAddress(zipCode)
        if (results && results.length > 0) {
          const addressComponents = results[0].address_components
          const googleState = addressComponents.find((comp) =>
            comp.types.includes('administrative_area_level_1')
          )

          if (googleState && googleState.long_name !== state) {
            errors[zipFieldName] = 'The entered ZIP code does not match the selected state.'
          }
        } else {
          errors[zipFieldName] = 'No results found for this ZIP code.'
        }
      } catch (error) {
        console.error('Error validating ZIP code:', error)
        errors[zipFieldName] = 'Unable to validate ZIP code. Please try again.'
      }
    }

    // Validate both service and billing ZIP codes
    await Promise.all([
      validateZipWithState(values.serviceZipCode, values.serviceState, 'serviceZipCode'),
      validateZipWithState(values.billingZipCode, values.billingState, 'billingZipCode'),
    ])

    return errors
  }

  const electricValidations = {
    rate: Yup.number()
      .required('E_Rate is required')
      .typeError('E_Rate must be a number')
      .positive('E_Rate must be positive')
      .min(limitValue.rateMin, `E_Rate must be at least ${limitValue.rateMin}`)
      .max(limitValue.rateMax, `E_Rate cannot be more than ${limitValue.rateMax}`),
    term: Yup.number()
      .required('E_Term is required')
      .typeError('E_Term must be a number')
      .positive('E_Term must be positive')
      .min(limitValue.termMin, `E_Term must be at least ${limitValue.termMin}`)
      .max(limitValue.termMax, `E_Term cannot be more than ${limitValue.termMax}`),
    brand: Yup.string().required('Brand is required'),
  }
  const gasValidations = {
    grate: Yup.number()
      .required('G_Rate is required')
      .typeError('G_Rate must be a number')
      .positive('G_Rate must be positive')
      .min(limitValue.grateMin, `G_Rate must be at least ${limitValue.grateMin}`)
      .max(limitValue.grateMax, `G_Rate cannot be more than ${limitValue.grateMax}`),
    gterm: Yup.number()
      .required('G_Term is required')
      .typeError('G_Term must be a number')
      .positive('G_Term must be positive')
      .min(limitValue.gtermMin, `G_Term must be at least ${limitValue.gtermMin}`)
      .max(limitValue.gtermMax, `G_Term cannot be more than ${limitValue.gtermMax}`),
    gbrand: Yup.string().required('Brand is required'),
  }
  const basicValidations = {
    customerType: Yup.string().required('Customer type is required'),
    customerFirstName: Yup.string()
      .required('First Name is required')
      .matches(/^[0-9a-zA-Z \b-]+$/, SpecialCharMsg)
      .matches(/[^0-9]/, NumMsg)
      .min(3, "First Name shouldn't be less than 3 characters")
      .max(40, "First Name shouldn't exceed 40 characters"),
    customerLastName: Yup.string()
      .required('Last Name is required')
      .matches(/^[0-9a-zA-Z \b-]+$/, SpecialCharMsg)
      .matches(/[^0-9]/, NumMsg)
      .min(1, "Last Name shouldn't be less than 1 character")
      .max(40, "Last Name shouldn't exceed 40 characters"),
    dateOfBirth: isSolarProduct
      ? Yup.string()
          .required('Date of Birth is required')
          .test('is-18', 'Customer must be at least 18 years old', (value) => {
            if (!value) return false
            const dob = new Date(value)
            const today = new Date()
            const age = today.getFullYear() - dob.getFullYear()

            return (
              age > 18 || (age === 18 && today >= new Date(dob.setFullYear(dob.getFullYear() + 18)))
            )
          })
      : Yup.string(),
    customerPhoneNumber: Yup.string()
      .matches(/[^a-zA-Z]/, 'Invalid mobile number')
      .min(10, mobileNumMsg)
      .max(10, "Mobile number shouldn't exceed 10 digits")
      .matches(/^[0-9a-zA-Z \b]+$/, SpecialCharMsg)
      .matches(
        /^(\+|1\s)?(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
        InvalidMobileNumMsg
      ),
    customerEmailId: Yup.string()
      .email(EmailMsg)
      .matches(/^(?!.*@[^,]*,)/, EmailMsg)
      .min(10, EmailMinimumValidation)
      .max(40, EmailMaximumValidation),
    customerPrimaryPhoneNumber: Yup.string()
      .required('Primary phone number is required')
      .matches(/[^a-zA-Z]/, InvalidNumMsg)
      .min(10, PhoneNumMsg)
      .max(10, "Phone number shouldn't exceed 10 digits")
      .matches(/^[0-9a-zA-Z \b]+$/, SpecialCharMsg)
      .matches(
        /^(\+|1\s)?(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
        InvalidNumMsg
      ),
    serviceAddress: Yup.string()
      .required(AddressMsg)
      .min(3, "Address shouldn't be less than 3 characters")
      .max(230, AddressExceedMsg),

    serviceState: Yup.string().required(StateMsg),
    serviceCity: Yup.string()
      .required(CityMsg)
      .min(3, CityMinimumValidation)
      .max(40, CityExceedMsg),
    serviceZipCode: Yup.string()
      .required(ZipMsg)
      .matches(/^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/, ZipCodeMsg),
  }
  // validation configs if service address is not same as billing
  const validationSchemaServiceNotSameAsBill = {
    ...validationSchema,
    billingAddress: Yup.string()
      .required(AddressMsg)
      .min(3, "Address shouldn't less than 3 characters")
      .max(230, AddressExceedMsg),
    billingState: Yup.string().required(StateMsg),
    billingCity: Yup.string()
      .required(CityMsg)
      .min(3, CityMinimumValidation)
      .max(40, CityExceedMsg),
    billingZipCode: Yup.string()
      .required(ZipMsg)
      .matches(/^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/, ZipCodeMsg),
  }
  useEffect(() => {
    if (isServiceSameAsBill) {
      setValidationSchema(basicValidations)
    } else {
      setValidationSchema(validationSchemaServiceNotSameAsBill)
    }
  }, [isServiceSameAsBill])

  useEffect(() => {
    if (documentDelivery === 'EMAIL') {
      setValidationSchema({
        ...validationSchema,
        customerEmailId: Yup.string()
          .email(EmailMsg)
          .required('Email is required')
          .matches(/^(?!.*@[^,]*,)/, EmailMsg)
          .min(10, EmailMinimumValidation)
          .max(40, EmailMaximumValidation),
      })
    } else {
      setValidationSchema({
        ...validationSchema,
        customerEmailId: Yup.string()
          .email(EmailMsg)
          .matches(/^(?!.*@[^,]*,)/, EmailMsg)
          .min(10, EmailMinimumValidation)
          .max(40, EmailMaximumValidation),
      })
    }
    formik.validateForm()
  }, [documentDelivery])

  const enrollSchema = Yup.object().shape(
    isSolarProduct
      ? validationSchema
      : isCommercialCustomer
      ? {
          ...validationSchema,
          businessName: Yup.string()
            .required('Business name is required')
            .nullable()
            .matches(/^[0-9a-zA-Z \b]+$/, SpecialCharMsg)
            .min(3, "Business Name shouldn't be less than 3 characters")
            .max(40, "Business Name shouldn't exceed 40 characters"),
        }
      : validationSchema
  )

  useEffect(() => {
    formik.validateForm()
  }, [validationSchema])

  useEffect(() => {
    if (show) {
      setValidationSchema({
        customerType: Yup.string().required('Customer type is required'),
        customerFirstName: Yup.string()
          .required('First Name is required')
          .matches(/^[0-9a-zA-Z \b]+$/, SpecialCharMsg)
          .matches(/[^0-9]/, NumMsg)
          .min(3, "First Name shouldn't be less than 3 characters")
          .max(40, "First Name shouldn't exceed 40 characters"),
        customerLastName: Yup.string()
          .required('Last Name is required')
          .matches(/^[0-9a-zA-Z \b]+$/, SpecialCharMsg)
          .matches(/[^0-9]/, NumMsg)
          .min(1, "Last Name shouldn't be less than 1 character")
          .max(40, "Last Name shouldn't exceed 40 characters"),
        dateOfBirth: isSolarProduct
          ? Yup.string()
              .required('Date of Birth is required')
              .test('is-18', 'Customer must be at least 18 years old', (value) => {
                if (!value) return false // Required validation already handles empty value
                const dob = new Date(value)
                const today = new Date()
                const age = today.getFullYear() - dob.getFullYear()

                // Check if DOB is at least 18 years ago
                return (
                  age > 18 ||
                  (age === 18 && today >= new Date(dob.setFullYear(dob.getFullYear() + 18)))
                )
              })
          : Yup.string(),
        customerPhoneNumber: Yup.string()
          .matches(/[^a-zA-Z]/, 'Invalid mobile number')
          .min(10, mobileNumMsg)
          .max(10, "Phone Number shouldn't exceed 10 digits")
          .matches(/^[0-9a-zA-Z \b]+$/, SpecialCharMsg)
          .matches(
            /^(\+|1\s)?(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
            InvalidNumMsg
          ),
        customerEmailId: Yup.string()
          .email(EmailMsg)
          .matches(/^(?!.*@[^,]*,)/, EmailMsg)
          .min(10, EmailMinimumValidation)
          .max(40, EmailMaximumValidation),
        customerPrimaryPhoneNumber: Yup.string()
          .required('Primary phone number is required')
          .matches(/[^a-zA-Z]/, InvalidNumMsg)
          .min(10, PhoneNumMsg)
          .max(10, "Phone number shouldn't exceed 10 digits")
          .matches(/^[0-9a-zA-Z \b]+$/, SpecialCharMsg)
          .matches(
            /^(\+|1\s)?(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
            InvalidNumMsg
          ),

        serviceAddress: Yup.string()
          .required(AddressMsg)
          .min(3, "Address shouldn't be less than 3 characters")
          .max(230, AddressExceedMsg),

        serviceState: Yup.string().required(StateMsg),
        serviceCity: Yup.string()
          .required(CityMsg)
          .matches(/^[A-Za-z- ]+$/, CityNameMsg)
          .min(3, CityMinimumValidation)
          .max(40, CityExceedMsg),
        serviceZipCode: Yup.string()
          .required(ZipMsg)
          .matches(/^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/, ZipCodeMsg),
        billingAddress: Yup.string()
          .required(AddressMsg)
          .min(3, "Address shouldn't less than 3 characters")
          .max(230, AddressExceedMsg),
        billingState: Yup.string().required(StateMsg),
        billingCity: Yup.string()
          .required(CityMsg)
          .matches(/^[A-Za-z- ]+$/, CityNameMsg)
          .min(3, CityMinimumValidation)
          .max(40, CityExceedMsg),
        billingZipCode: Yup.string()
          .required(ZipMsg)
          .matches(/^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/, ZipCodeMsg),
      })
      getCustomerFeatureFlags()
      setIsCommercialCustomer(false)
      setIsExistingCustomer(false)
      setIsServiceSameAsBill(false)
      if (modalConfig.mode === 'create') {
        setHasError(false)
        formik.setValues({...defaultAgentEnrollment})
        formik.setTouched({}, false)
        formik.setErrors({})
        setCustomer('')
        setDocumentDelivery('MAIL')
      } else if (modalConfig.mode === 'edit') {
        // fetch api call here and formik.setValues({...(response from api)})
        getCustomerById()
      }
    }
    // reseting the form when closed
    setHasFieldError(false)
  }, [show, editId])

  //helper fn to check upload status for bill image
  const checkUploadStatus = async (trackId: any, toasterReq = true) => {
    const tempHeader: any = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('_accesstoken')}`,
    }
    const url = SERVER_URL || ''
    if (Boolean(trackId)) {
      const response = await fetch(url, {
        method: 'POST',
        headers: new Headers(tempHeader),
        body: JSON.stringify({
          query: TRACK_IMAGE_UPLOADED,
          variables: {
            trackId,
          },
        }),
      })
        .then((res) => {
          return res.json()
        })
        .catch((error) => {
          toaster(`${error.message}`, 'error')
        })
      const apiResponse = await response
      if (apiResponse.data.trackImageUploaded.status === 'Inprogress') {
        toasterReq && toaster('Tracking customer bill', 'info')
        setTimeout(() => {
          if (Boolean(trackIdRef.current)) {
            checkUploadStatus(trackIdRef.current, true)
          }
        }, 3000)
      } else if (apiResponse.data.trackImageUploaded.status === 'success') {
        formik.setFieldValue('customerBillUrl', apiResponse.data.trackImageUploaded.billImageUrl)
      }
    }
  }

  const trackIdRef = useRef<string>('')
  //to trigger customer bill SMS

  const [getCipherMessage] = useLazyQuery(GET_CIPHER_MESSAGE, {
    onCompleted: (data) => {
      // Use MySwal to show the SweetAlert with React content
      MySwal.fire({
        title: 'Message Sent!',
        text: data.getCipherMessage,
        icon: 'success',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.isConfirmed) {
          checkUploadStatus(trackIdRef.current)
        }
      })
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  //to trigger customer bill email

  const [getCipherEmail] = useLazyQuery(GET_CIPHER_EMAIL, {
    onCompleted: (data) => {
      // Use MySwal to show the SweetAlert with React content
      MySwal.fire({
        title: 'Email Sent!',
        text: data.getCipherEmail,
        icon: 'success',
        confirmButtonText: 'OK',
      }).then((result) => {
        if (result.isConfirmed) {
          checkUploadStatus(trackIdRef.current)
        }
      })
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  // to check phone number optin
  const [checkPhonenumberOptin] = useLazyQuery(CHECK_PHONE_NUMBER_OPTIN, {
    onCompleted: (data) => {
      setIsOptedIn(data.checkPhoneNumberOptinStatus.optinStatus)
      if (
        !data.checkPhoneNumberOptinStatus.optinStatus &&
        data.checkPhoneNumberOptinStatus.dialInNumber
      ) {
        setClientDialInNumber(data.checkPhoneNumberOptinStatus.dialInNumber)
      }
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  const [getCustomerById, {data: getcustomerByIdData}] = useLazyQuery(
    GET_CUSTOMER_ENROLLMENT_BY_ID,
    {
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
      variables: {
        id: modalConfig.editId,
      },
      onCompleted: (customerData1) => {
        const gasDetails =
          customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
            (details: any) => details?.productType === 'Gas'
          ).length > 0
            ? customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
                (details: any) => details?.productType === 'Gas'
              )[0]
            : null
        const electricDetails =
          customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
            (details: any) => details?.productType === 'Electric'
          ).length > 0
            ? customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
                (details: any) => details?.productType === 'Electric'
              )[0]
            : null

        const SolarDetails =
          customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
            (details: any) => details?.productType === 'Solar'
          ).length > 0
            ? customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
                (details: any) => details?.productType === 'Solar'
              )[0]
            : null

        const editAgentEnrollment = {
          billUrls: customerData1.getCustomerEnrollmentById?.customerBillUrl,
          customerBillUrl: customerData1.getCustomerEnrollmentById?.customerBillUrl,
          businessName: customerData1.getCustomerEnrollmentById?.businessName,
          customerType: customerData1.getCustomerEnrollmentById.customerType?.name,
          customerTypeId: customerData1.getCustomerEnrollmentById.customerType?.id,
          customerFirstName: customerData1.getCustomerEnrollmentById.firstName,
          customerLastName: customerData1.getCustomerEnrollmentById.lastName,
          customerEmailId: customerData1.getCustomerEnrollmentById.emailId,
          customerPhoneNumber: customerData1.getCustomerEnrollmentById.mobileNumber,
          customerPrimaryPhoneNumber: customerData1.getCustomerEnrollmentById.primaryPhoneNumber,
          serviceAddress: customerData1.getCustomerEnrollmentById.serviceAddress1,
          serviceAddress2: customerData1.getCustomerEnrollmentById.serviceAddress2,
          serviceCountry: customerData1.getCustomerEnrollmentById.serviceCountry,
          serviceState: customerData1.getCustomerEnrollmentById.serviceState,
          serviceCity: customerData1.getCustomerEnrollmentById.serviceCity,
          serviceZipCode: customerData1.getCustomerEnrollmentById.serviceZipCode,
          billingAddress: customerData1.getCustomerEnrollmentById.billingAddress1,
          billingAddress2: customerData1.getCustomerEnrollmentById.billingAddress2,
          billingCountry: customerData1.getCustomerEnrollmentById.billingCountry,
          billingAddressCheckbox: '',
          billingState: customerData1.getCustomerEnrollmentById.billingState,
          billingCity: customerData1.getCustomerEnrollmentById.billingCity,
          billingZipCode: customerData1.getCustomerEnrollmentById.billingZipCode,
          dateOfBirth: customerData1.getCustomerEnrollmentById.dateOfBirth,
          isMixMatch: customerData1.getCustomerEnrollmentById.isMixMatch,
          utilityAccountNumber:
            customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
              (uan: any) => uan?.productType === 'Electric'
            ).length > 0
              ? customerData1.getCustomerEnrollmentById.customerEnrollments.filter(
                  (uan: any) => uan?.productType === 'Electric'
                )[0]?.utilityAccountNumber
              : isSolarProduct
              ? customerData1?.getCustomerEnrollmentById?.customerEnrollments[0]
                  ?.utilityAccountNumber
              : null,
          utilityAccountNumberId:
            customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
              (uan: any) => uan?.productType === 'Electric'
            ).length > 0
              ? customerData1.getCustomerEnrollmentById.customerEnrollments.filter(
                  (uan: any) => uan?.productType === 'Electric'
                )[0]?.id
              : isSolarProduct
              ? customerData1?.getCustomerEnrollmentById?.customerEnrollments[0]?.id
              : null,
          languageId: customerData1.getCustomerEnrollmentById.languageId,
          benefitProgramId:
            customerData1?.getCustomerEnrollmentById?.customerEnrollments[0]?.benefitProgramId,
          productName: customerData1.getCustomerEnrollmentById.product.id,
          rate: Boolean(electricDetails?.rate) ? electricDetails?.rate : null,
          term: Boolean(electricDetails?.term) ? electricDetails?.term : null,
          contractStartDate: Boolean(electricDetails?.contractStartDate)
            ? electricDetails?.contractStartDate
            : Boolean(SolarDetails?.contractStartDate)
            ? SolarDetails?.contractStartDate
            : '',

          grate: Boolean(gasDetails?.rate) ? gasDetails.rate : null,
          gterm: Boolean(gasDetails?.term) ? gasDetails.term : null,
          gcontractStartDate: Boolean(gasDetails?.contractStartDate)
            ? gasDetails?.contractStartDate
            : '',

          brand: Boolean(electricDetails?.brandType?.name)
            ? electricDetails?.brandType?.name
            : null,
          gbrand: Boolean(gasDetails?.brandType?.name) ? gasDetails?.brandType?.name : null,
          id: customerData1.getCustomerEnrollmentById.id,
          documentDelivery: customerData1.getCustomerEnrollmentById.documentDelivery,
          tpvStatus: customerData1.getCustomerEnrollmentById.tpvStatus,
          transferPhoneNumber: customerData1.getCustomerEnrollmentById.transferPhoneNumber,
          pincode: customerData1.getCustomerEnrollmentById.pincode,
          gutilityAccountNumber:
            customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
              (uan: any) => uan?.productType === 'Gas'
            ).length > 0
              ? customerData1.getCustomerEnrollmentById.customerEnrollments.filter(
                  (uan: any) => uan?.productType === 'Gas'
                )[0]?.utilityAccountNumber
              : null,
          gutilityAccountNumberId:
            customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
              (uan: any) => uan?.productType === 'Gas'
            ).length > 0
              ? customerData1.getCustomerEnrollmentById.customerEnrollments.filter(
                  (uan: any) => uan?.productType === 'Gas'
                )[0]?.id
              : null,
          commodity: '',
          commodityId: '',
          tpvType: customerData1?.getCustomerEnrollmentById?.tpvType,
          tpvId: customerData1?.getCustomerEnrollmentById?.tpvId,
          selectedProductCommodity:
            customerData1?.getCustomerEnrollmentById?.product?.commodity?.name,
          address: '',
          electricMixMatchProductId: customerData1.getCustomerEnrollmentById.isMixMatch
            ? customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
                (uan: any) => uan?.productType === 'Electric'
              )[0]?.productId
            : '',
          gasMixMatchProductId: customerData1.getCustomerEnrollmentById.isMixMatch
            ? customerData1?.getCustomerEnrollmentById?.customerEnrollments?.filter(
                (uan: any) => uan?.productType === 'Gas'
              )[0]?.productId
            : '',
          meterId: Boolean(electricDetails?.utilityMeterNumber)
            ? electricDetails?.utilityMeterNumber
            : Boolean(SolarDetails?.utilityMeterNumber)
            ? SolarDetails?.utilityMeterNumber
            : '',
          gmeterId: Boolean(gasDetails?.utilityMeterNumber)
            ? electricDetails?.utilityMeterNumber
            : null,
        }
        if (Boolean(customerData1.getCustomerEnrollmentById.businessName)) {
          formik.setFieldValue('businessName', customerData1?.getCustomerByUanOrPhone?.businessName)
          setIsCommercialCustomer(true)
        }
        if (
          customerData1.getCustomerEnrollmentById.billingAddress1 ===
            customerData1.getCustomerEnrollmentById.serviceAddress1 &&
          customerData1.getCustomerEnrollmentById.billingAddress2 ===
            customerData1.getCustomerEnrollmentById.serviceAddress2
        ) {
          setIsServiceSameAsBill(true)
        }
        formik.setValues((prevValues) => ({
          ...prevValues,
          ...editAgentEnrollment,
        }))

        getProductLanguage({
          variables: {
            productId: customerData1.getCustomerEnrollmentById.product.id,
            tpvId: customerData1?.getCustomerEnrollmentById?.tpvId,
          },
        })
        const editProductDetails = {
          id: customerData1.getCustomerEnrollmentById.customerEnrollments[0].productId,
          name: customerData1.getCustomerEnrollmentById.product?.name,
          ecode: Boolean(electricDetails?.code) ? electricDetails?.code : null,
          rate: Boolean(electricDetails?.rate) ? electricDetails?.rate : null,
          term: Boolean(electricDetails?.term) ? electricDetails?.term : null,
          isDynamicProduct: electricDetails?.isDynamicProductEnrollment,
          commodity: customerData1.getCustomerEnrollmentById.product?.commodity,
          earlyTerminationFee: Boolean(electricDetails?.earlyTerminationFee)
            ? electricDetails.earlyTerminationFee
            : null,
          serviceFee: Boolean(electricDetails?.serviceFee) ? electricDetails.serviceFee : null,
          grate: Boolean(gasDetails?.rate) ? gasDetails.rate : null,
          gterm: Boolean(gasDetails?.term) ? gasDetails.term : null,
          gearlyTerminationFee: Boolean(gasDetails?.earlyTerminationFee)
            ? gasDetails.earlyTerminationFee
            : null,
          gserviceFee: Boolean(gasDetails?.serviceFee) ? gasDetails.serviceFee : null,
          gcode: Boolean(gasDetails?.code) ? gasDetails?.code : null,
          gisDynamicProduct: gasDetails?.isDynamicProductEnrollment,
          isEditable: true,
          rateMinimum:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.rateMinimum,
          rateMaximum:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.rateMaximum,
          termMinimum:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.termMinimum,
          termMaximum:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.termMaximum,
          grateMinimum:
            customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.rateMinimum,
          grateMaximum:
            customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.grateMaximum,
          gtermMinimum:
            customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.gtermMinimum,
          gtermMaximum:
            customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.gtermMaximum,
        }
        setProductDetails(editProductDetails)
        setLimitValue((prevValues: any) => ({
          ...prevValues,
          rateMax:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.rateMaximum,
          rateMin:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.rateMinimum,
          termMax:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.termMaximum,
          termMin:
            customerData1?.getCustomerEnrollmentById?.electricEnrollment?.product?.termMinimum,
          grateMax: customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.grateMaximum,
          grateMin: customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.rateMinimum,
          gtermMax: customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.gtermMaximum,
          gtermMin: customerData1?.getCustomerEnrollmentById?.gasEnrollment?.product?.gtermMinimum,
        }))
      },
    }
  )
  //to get the sales channel feature flags
  const [getCustomerFeatureFlags, {data: customerFeatureFlags}] = useLazyQuery(
    GET_CUSTOMER_FEATURE_FLAGS,
    {
      onCompleted: (data) => {
        const methods = []
        const {
          enableIvr,
          enableLiveAgent,
          enableTextTpv,
          enableOutBoundLiveAgent,
          isMixMatch,
          enableContractStartDate,
          isUtilityMeterNumberRequired,
          billUploadOnlyByCamera,
          disableExistingCustomerEnrollment,
          enableZipCodeInUtility,
          enableContractRequired,
          enableNoTPV,
        } = data.getCustomerFeatureFlag

        if (enableIvr) {
          methods.push({value: GLOBAL_CONSTANTS.tpvType.ivr, text: 'IVR'})
        }
        if (enableLiveAgent) {
          methods.push({value: GLOBAL_CONSTANTS.tpvType.liveAgent, text: 'Live Agent'})
        }
        if (enableTextTpv) {
          methods.push({value: GLOBAL_CONSTANTS.tpvType.smsTpv, text: 'Text TPV'})
        }
        if (enableNoTPV) {
          methods.push({value: GLOBAL_CONSTANTS.tpvType.notpv, text: 'No TPV'})
        }
        if (enableOutBoundLiveAgent) {
          methods.push({
            value: GLOBAL_CONSTANTS.tpvType.outboundLiveAgent,
            text: 'Outbound Live Agent',
          })
        }

        // Set necessary state variables
        setIsMixmatch(isMixMatch)
        setIsEnableContractStartDate(enableContractStartDate)
        setIsUtilityMeterNumberRequired(isUtilityMeterNumberRequired)
        setDisableExistingCustomerEnrollment(disableExistingCustomerEnrollment)
        setForceCameraOpen(billUploadOnlyByCamera)
        setTpvMethods(methods)
        setEnableContractRequired(enableContractRequired)

        // Update validation schema based on feature flags

        if (customerFeatureFlags?.getCustomerFeatureFlag?.enableSmsDocumentVerification) {
          setValidationSchema({
            ...validationSchema,
            contractbySms: Yup.boolean().oneOf(
              [true],
              'Contract type must be selected if SMS is enabled'
            ),
          })
        }

        if (customerFeatureFlags?.getCustomerFeatureFlag?.enableEmailDocumentVerification) {
          setValidationSchema({
            ...validationSchema,
            contractbyEmail: Yup.boolean().oneOf(
              [true],
              'Contract type must be selected if Email is enabled'
            ),
          })
        }

        // // Add custom validation to ensure at least one is selected
        // updatedValidationSchema = updatedValidationSchema.test('either-or', 'At least one contract type must be selected', function (value) {
        //   const { contractbySms, contractbyEmail } = this.parent;

        //   const smsEnabled = customerFeatureFlags?.getCustomerFeatureFlag?.enableSmsDocumentVerification;
        //   const emailEnabled = customerFeatureFlags?.getCustomerFeatureFlag?.enableEmailDocumentVerification;

        //   if (smsEnabled || emailEnabled) {
        //     return contractbySms === true || contractbyEmail === true;
        //   }

        //   return true; // If neither feature is enabled, return true
        // });

        // // Set the updated validation schema
      },
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    }
  )

  //to validate whether phone/zipcode/uan is part of DNE
  const [validateCustomerInfo, {loading: validateLoading}] = useLazyQuery(VALIDATE_CUSTOMER_INFO, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  const primaryPhoneValidation = _.debounce((phoneNumber) => {
    validateCustomerInfo({
      variables: {
        validateCustomerInput: {
          primaryPhoneNumber: phoneNumber,
        },
      },
      onCompleted: (detail) => {
        if (detail.validateCustomer.isExistsInDne) {
          MySwal.fire({
            icon: 'error',
            title:
              'This customer is part of Do Not Enroll list . Please contact the Admin to proceed.',
            // text: 'Something went wrong!',
          }).then(() => {
            if (!stepper.current) {
              return
            }
            setCurrentScreen(0)
            stepper.current.goFirst()
          })
          formik.setValues({
            ...formik.values,
            customerPhoneNumber: '',
            utilityAccountNumber: '',
            gutilityAccountNumber: '',
            customerPrimaryPhoneNumber: '',
          })
          if (isExistingCustomer) {
            setSearchText('')
            getCustomerByPhoneNumber({variables: {uanOrPhoneNumber: null}})
          }
        }
      },
    })
  }, 500)

  const UANValidation = _.debounce((UANNumber) => {
    validateCustomerInfo({
      variables: {
        validateCustomerInput: {
          utilityAccountNumber: UANNumber,
        },
      },
      onCompleted: (detail) => {
        if (detail.validateCustomer.isExistingCustomer) {
          areYouSurePrompt(
            'Utility Account Number already exists!',
            () => {
              setIsExistingCustomer(true)
            },
            () => {
              formik.setValues({
                ...formik.values,
                utilityAccountNumber: '',
                gutilityAccountNumber: '',
              })
            },

            isSolarProduct ? undefined : 'Yes',
            isSolarProduct ? 'Go Back' : 'No',
            undefined,
            isSolarProduct
              ? 'Agent, this Utility Account Number already exists and cannot be enrolled.<br><br>Check if the Customer would like to submit another Utility Account Number instead.'
              : 'Agent, this Utility Account Number already exists, would you like to proceed?'
          )
        } else if (detail.validateCustomer.isExistsInDne) {
          MySwal.fire({
            icon: 'error',
            title:
              'This customer is part of Do Not Enroll list . Please contact the Admin to proceed.',
            // text: 'Something went wrong!',
          }).then(() => {
            if (!stepper.current) {
              return
            }
            setCurrentScreen(0)
            stepper.current.goFirst()
          })
          formik.setValues({
            ...formik.values,
            customerPhoneNumber: '',
            utilityAccountNumber: '',
            gutilityAccountNumber: '',
            customerPrimaryPhoneNumber: '',
          })
          if (isExistingCustomer) {
            setSearchText('')
            getCustomerByPhoneNumber({variables: {uanOrPhoneNumber: null}})
          }
        }
      },
    })
  }, 500)

  const emailAlreadyExists = _.debounce((EmailId) => {
    validateCustomerInfo({
      variables: {
        validateCustomerInput: {
          emailId: EmailId,
        },
      },
      onCompleted: (detail) => {
        if (detail.validateCustomer.isExistsInDne) {
          areYouSurePrompt(
            'This email is do not enroll list!',
            () => {
              setIsExistingCustomer(true)
            },
            () => {
              formik.setValues({
                ...formik.values,
                customerEmailId: '',
              })
            },
            undefined,
            'Exit',
            'Agent, this email is part of Do Not Enroll list aske coustomer to provide another email'
          )
        } else if (detail.validateCustomer.isExistingAgent) {
          areYouSurePrompt(
            'This email is already registered as an Agent!',
            () => {
              setIsExistingCustomer(true)
            },
            () => {
              formik.setValues({
                ...formik.values,
                customerEmailId: '',
              })
            },
            undefined,
            'Exit',
            '"Agent, this email is already registered as an Agent. Ask the customer to provide another email'
          )
        } else if (detail.validateCustomer.isExistingCustomer) {
          areYouSurePrompt(
            'Email already exists!',
            () => {
              setIsExistingCustomer(true)
            },
            () => {
              formik.setValues({
                ...formik.values,
                customerEmailId: '',
              })
            },
            'Yes',
            'No',
            'Agent, this Email already exists, would you like to proceed?'
          )
        }
      },
    })
  }, 500)

  // const validateNumber = (number: any) => {
  //   validateCustomerInfo({
  //     variables: {
  //       validateCustomerInput: {
  //         utilityAccountNumber: number,
  //         primaryPhoneNumber: number,
  //         mobileNumber: number,
  //       },
  //     },
  //   })
  // }
  const [getCustomerByPhoneNumber, {loading: customerLoading, data: customerData}] = useLazyQuery(
    GET_CUSTOMER_BY_UAN_OR_PHONENUMBER,
    {
      onCompleted: (data) => {
        checkPhonenumberOptin({
          variables: {
            phoneNumber: data.getCustomerByUanOrPhone.primaryPhoneNumber,
          },
        })
        formik.setTouched(fieldTouched(true))
        formik.setErrors({})
      },
      onError: (err) => {
        formik.setTouched(fieldTouched(false))

        setCustomer(err.message)
      },
      fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    }
  )

  //sms handler for bill image
  const sendSMSHandler = async () => {
    let generatedUuid: string = uuid()
    trackIdRef.current = generatedUuid
    await getCipherMessage({
      variables: {
        customerId: modalConfig.editId ? modalConfig.editId : null,
        primaryPhoneNumber: `+1${formik.values.customerPrimaryPhoneNumber}`,
        trackId: generatedUuid,
      },
    })
  }
  const sendBillImageEmailHandler = async () => {
    let generatedUuid: string = uuid()
    trackIdRef.current = generatedUuid
    await getCipherEmail({
      variables: {
        customerId: null,
        emailId: formik.values.customerEmailId,
        trackId: generatedUuid,
      },
    })
  }
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const updateData = (fieldsToUpdate: Partial<IAgentEnrollmentData>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    setData(updatedData)
  }

  //config for customer info page validation
  const basicCheckFields = () => {
    return isServiceSameAsBill
      ? (isCommercialCustomer && formik.errors.businessName) ||
          formik.errors.customerType ||
          formik.errors.customerFirstName ||
          formik.errors.customerLastName ||
          formik.errors.customerEmailId ||
          formik.errors.customerPrimaryPhoneNumber ||
          formik.errors.customerPhoneNumber ||
          formik.errors.serviceAddress ||
          formik.errors.serviceState ||
          formik.errors.serviceCity ||
          formik.errors.serviceZipCode ||
          (isSolarProduct ? formik.errors.dateOfBirth : false) ||
          (documentDelivery === 'EMAIL' ? formik.values.customerEmailId === '' : false) ||
          validateLoading
      : (isCommercialCustomer && formik.errors.businessName) ||
          formik.errors.customerTypeId ||
          formik.errors.customerFirstName ||
          formik.errors.customerLastName ||
          (isSolarProduct ? formik.errors.dateOfBirth : false) ||
          formik.errors.customerEmailId ||
          formik.errors.customerPrimaryPhoneNumber ||
          formik.errors.customerPhoneNumber ||
          formik.errors.serviceAddress ||
          formik.errors.serviceState ||
          formik.errors.serviceCity ||
          formik.errors.serviceZipCode ||
          formik.errors.billingAddress ||
          formik.errors.billingState ||
          formik.errors.billingCity ||
          formik.errors.billingZipCode ||
          formik.values.billingAddress === '' ||
          formik.values.billingCity === '' ||
          formik.values.billingZipCode === '' ||
          formik.errors.billingState ||
          (documentDelivery === 'EMAIL' ? formik.values.customerEmailId === '' : false) ||
          validateLoading
  }

  const checkAppBasic = (): boolean => {
    if (basicCheckFields()) {
      const customerInfo = [
        'businessName',
        'customerType',
        'customerFirstName',
        'customerLastName',
        'customerEmailId',
        'customerPhoneNumber',
        'customerPrimaryPhoneNumber',
        'serviceAddress',
        'serviceState',
        'serviceCity',
        'serviceZipCode',
        'billingAddressCheckbox',
        'billingAddress',
        'billingState',
        'billingCity',
        'billingZipCode',
        'dateOfBirth',
      ]
      console.log(Object.keys(formik.errors), '>>>>qwertyui')
      if (customerInfo.includes(Object.keys(formik.errors)[0])) {
        const errorElement = document.getElementById(Object.keys(formik.errors)[0])
        errorElement?.scrollIntoView({behavior: 'smooth', block: 'center'})
        errorElement?.focus({preventScroll: true})
      }
      setHasFieldError(true)
      return false
    }
    return true
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    setCurrentScreen((prev) => prev - 1)
    stepper.current.goPrev()
  }
  const handleClick = () => {
    if (
      (customerBillImage ? enableCustomerBillImage && imageUploadRequired : imageUploadRequired) &&
      uploadedFiles.length === 0 &&
      formik?.values?.customerBillUrl?.length === 0
    ) {
      setHasError(true)
      setFileUploadError('Image upload required')
      return
    }
    formik.submitForm()
  }

  const nextStep = () => {
    // formik.setTouched(fieldTouched(true))
    setHasError(false)

    if (!locationEnabled && (sendContract || sendContractEmail)) {
      checkLocationEnabled()
      return
    }
    if (!stepper.current) {
      return
    }
    if (stepper.current.getCurrentStepIndex() === 1) {
      formik.setTouched({customerPrimaryPhoneNumber: true})
      if (
        !Boolean(formik.values.customerPrimaryPhoneNumber) ||
        formik.errors.customerPrimaryPhoneNumber
      ) {
        return
      }
      if (formik.errors.customerPrimaryPhoneNumber || formik.errors.customerPhoneNumber) {
        setHasError(true)
        return
      }
      setCurrentScreen(2)
    }
    if (stepper.current.getCurrentStepIndex() === 2) {
      formik.setFieldTouched('customerType', true)
      formik.setFieldTouched('serviceState', true)
      formik.setFieldTouched('billingState', true)
      formik.validateForm()
      console.log(!checkAppBasic(), '>>>>>>>!checkAppBasic()')
      if (!checkAppBasic() && Boolean(Object.keys(formik.errors).length)) {
        setHasError(true)
        if (!validateLoading) {
          bussinessRef?.current?.focus()
          bussinessRef?.current?.blur()
        }
        return
      }
      setCurrentScreen(3)
    }
    if (stepper.current.getCurrentStepIndex() === 2 && enableContractRequired) {
      if (modalConfig.mode === 'create' && !sendContract && !sendContractEmail) {
        alert('Contract not selected. Please select.', 'error')
        setHasError(true)
        return
      }
      setCurrentScreen(2)
    }

    if (stepper.current.getCurrentStepIndex() === 3) {
      let formikErrorObjectKeys = Object.keys(formik.errors)
      if (
        formikErrorObjectKeys.includes('gutilityAccountNumber') ||
        formikErrorObjectKeys.includes('utilityAccountNumber') ||
        formikErrorObjectKeys.includes('productName') ||
        !Boolean(formik.values.tpvType) ||
        ((customerBillImage
          ? enableCustomerBillImage && imageUploadRequired
          : imageUploadRequired) &&
          uploadedFiles.length === 0 &&
          formik?.values?.customerBillUrl?.length === 0)
      ) {
        setHasError(true)
        setFileUploadError('Image upload required')
        return
      }
      setCurrentScreen(4)
    }
    stepper.current.goNext()
  }
  //helper function to assign commodity value in payload
  const handleCustomerUan = () => {
    if (productDetails?.commodity?.name === 'Dual' || formik.values.isMixMatch) {
      return [
        {
          productType: 'ELECTRIC',
          utilityAccountNumber: formik.values.utilityAccountNumber,
          brandTypeId: formik.getFieldMeta('brandId').value,
          rate: Number(formik.values.rate),
          term: formik.values.term,
          contractStartDate: moment(formik.values.contractStartDate).format('YYYY-MM-DD'),
          utilityMeterNumber: formik.values.meterId,
        },
        {
          productType: 'GAS',
          utilityAccountNumber: formik.values.gutilityAccountNumber,
          brandTypeId: formik.getFieldMeta('gbrandId').value,
          rate: Number(formik.values.grate),
          term: formik.values.gterm,
          contractStartDate: moment(formik.values.gcontractStartDate).format('YYYY-MM-DD'),
          utilityMeterNumber: formik.values.gmeterId,
        },
      ]
    } else if (productDetails?.commodity?.name === 'Electric') {
      return [
        {
          productType: 'ELECTRIC',
          utilityAccountNumber: formik.values.utilityAccountNumber,
          brandTypeId: formik.getFieldMeta('brandId').value,
          rate: Number(formik.values.rate),
          term: formik.values.term,
          contractStartDate: moment(formik.values.contractStartDate).format('YYYY-MM-DD'),
          utilityMeterNumber: formik.values.meterId,
        },
      ]
    } else if (productDetails?.commodity?.name === 'Gas') {
      return [
        {
          productType: 'GAS',
          utilityAccountNumber: formik.values.gutilityAccountNumber,
          brandTypeId: formik.getFieldMeta('gbrandId').value,
          rate: Number(formik.values.grate),
          term: formik.values.gterm,
          contractStartDate: moment(formik.values.gcontractStartDate).format('YYYY-MM-DD'),
          utilityMeterNumber: formik.values.gmeterId,
        },
      ]
    } else if (isSolarProduct) {
      return [
        {
          productType: 'SOLAR',
          utilityAccountNumber: formik.values.utilityAccountNumber,
          ...(formik.values.contractStartDate && {
            contractStartDate: moment(formik.values.contractStartDate).format('YYYY-MM-DD'),
          }),
          utilityMeterNumber: formik.values.meterId,
        },
      ]
    }
  }

  const handleCustomerUanEdit = () => {
    if (productDetails?.commodity?.name === 'Dual' || formik.values.isMixMatch) {
      return [
        {
          id: formik.values.utilityAccountNumberId,
          productType: 'ELECTRIC',
          utilityAccountNumber: formik.values.utilityAccountNumber,
        },
        {
          id: formik.values.gutilityAccountNumberId,
          productType: 'GAS',
          utilityAccountNumber: formik.values.gutilityAccountNumber,
        },
      ]
    } else if (productDetails?.commodity?.name === 'Electric') {
      console.log('>>>>>qwerty')
      return [
        {
          id: formik.values.utilityAccountNumberId,
          productType: 'ELECTRIC',
          utilityAccountNumber: formik.values.utilityAccountNumber,
        },
      ]
    } else if (productDetails?.commodity?.name === 'Gas') {
      return [
        {
          id: formik.values.gutilityAccountNumberId,
          productType: 'GAS',
          utilityAccountNumber: formik.values.gutilityAccountNumber,
        },
      ]
    } else if (isSolarProduct) {
      return [
        {
          id: formik.values.utilityAccountNumberId,
          productType: 'SOLAR',
          utilityAccountNumber: formik.values.utilityAccountNumber,
          ...(formik.values.benefitProgramId && {benefitProgramId: formik.values.benefitProgramId}),
        },
      ]
    }
  }
  //helper fn to handle create customer
  const handleCreateCustomer = async (
    values: FormikValues,
    createCustomerEnrollment: any,
    latlong: any
  ) => {
    setSubmitting(true)
    try {
      const newValues = await uploadFiles(uploadedFiles, true, 'billimages', 'billpdf')
      if (newValues) {
        const currentValues = formik.getFieldMeta('customerBillUrl').value
        const updatedValues = [...currentValues, ...newValues]
        formik.setFieldValue('customerBillUrl', updatedValues)

        await createCustomerEnrollment({
          variables: {
            createCustomerEnrollmentInput: {
              businessName: values.businessName,
              customerTypeId: values.customerTypeId,
              firstName: values.customerFirstName,
              lastName: values.customerLastName,
              emailId: values.customerEmailId,
              primaryPhoneNumber: values.customerPrimaryPhoneNumber,
              mobileNumber: values.customerPhoneNumber,
              serviceAddress1: values.serviceAddress,
              serviceAddress2: values.serviceAddress2,
              serviceCountry: values.serviceCountry,
              serviceState: values.serviceState,
              serviceCity: values.serviceCity,
              serviceZipCode: values.serviceZipCode,
              billingAddress1: isServiceSameAsBill ? values.serviceAddress : values.billingAddress,
              billingAddress2: isServiceSameAsBill
                ? values.serviceAddress2
                : values.billingAddress2,
              billingCountry: isServiceSameAsBill ? values.serviceCountry : values.billingCountry,
              billingState: isServiceSameAsBill ? values.serviceState : values.billingState,
              billingCity: isServiceSameAsBill ? values.serviceCity : values.billingCity,
              billingZipCode: isServiceSameAsBill ? values.serviceZipCode : values.billingZipCode,

              documentDelivery: values.documentDelivery,
              productId: values.isMixMatch
                ? values.electricMixMatchProductId
                : values.selectedProductCommodity === 'Gas'
                ? null
                : values.productName,
              languageId: values.languageId,
              customerEnrollments: handleCustomerUan(),
              isEnrollExistingCustomer: isExistingCustomer,
              customerTpvType: values.tpvType,
              sendDocumentBySMS: sendContract,
              sendDocumentByMail: sendContractEmail,
              agentLatitude: Boolean(agentCoords?.latitude) ? String(agentCoords?.latitude) : null,
              agentLongitude: Boolean(agentCoords?.longitude)
                ? String(agentCoords?.longitude)
                : null,
              trackId: trackIdRef.current,
              customerServiceBillLatitude: Boolean(latlong?.lat) ? String(latlong?.lat) : null,
              customerServiceBillLongitude: Boolean(latlong?.lng) ? String(latlong?.lng) : null,
              isMixMatch: values.isMixMatch,
              dateOfBirth: values.dateOfBirth,
              gProductId: values.isMixMatch
                ? values.gasMixMatchProductId
                : values.selectedProductCommodity === 'Electric'
                ? null
                : values.productName,
              billUrls: updatedValues.length > 0 ? updatedValues : [],
              phoneType: formik.values.linetype,
              ...(formik.values.benefitProgramId && {
                benefitProgramId: formik.values.benefitProgramId,
              }),
            },
          },
        })
      }
    } catch (error) {
      console.error('Error uploading files:', error)
    }
  }
  const formik = useFormik({
    initialValues: defaultAgentEnrollment,
    validationSchema: enrollSchema,
    // validate: validateZipCodeField,     //validate zipcode against state in agent screen.
    enableReinitialize: true,

    onSubmit: async (values) => {
      let latlong: any = null
      if (sendContract || sendContractEmail) {
        const result = await geocodeByAddress(
          `${values.serviceAddress}, ${values.serviceCity}, ${values.serviceState}, ${values.serviceCountry}`
        )
        latlong = await getLatLng(result[0])
      }

      if (modalConfig.mode === 'create') {
        if (isExistingCustomer) {
          await handleCreateCustomer(values, createCustomerEnrollment, latlong)
        } else {
          await validateCustomerInfo({
            variables: {
              validateCustomerInput: {
                primaryPhoneNumber: values.customerPrimaryPhoneNumber,
                utilityAccountNumber: values.utilityAccountNumber,
                gutilityAccountNumber: values.gutilityAccountNumber,
              },
            },
          }).then(async ({data}) => {
            if (data.validateCustomer.isExistingCustomer) {
              areYouSurePrompt(
                'Customer already exists!',
                () => handleCreateCustomer(values, createCustomerEnrollment, latlong),
                () => {},
                'Yes',
                'No',
                'Agent, this customer already exists, would you like to proceed?'
              )
            } else {
              await handleCreateCustomer(values, createCustomerEnrollment, latlong)
            }
          })
        }
      } else if (modalConfig.mode === 'edit' && !isExistingCustomer) {
        setSubmitting(true)
        await updateCustomerEnrollment({
          variables: {
            updateCustomerEnrollmentInput: {
              firstName: values.customerFirstName,
              lastName: values.customerLastName,
              businessName: values.businessName,
              customerTypeId: values.customerTypeId,
              emailId: values.customerEmailId,
              mobileNumber: values.customerPhoneNumber,
              primaryPhoneNumber: values.customerPrimaryPhoneNumber,
              serviceAddress1: values.serviceAddress,
              serviceAddress2: values.serviceAddress2,
              serviceCountry: values.serviceCountry,
              serviceState: values.serviceState,
              serviceCity: values.serviceCity,
              serviceZipCode: values.serviceZipCode,
              billingAddress1: isServiceSameAsBill ? values.serviceAddress : values.billingAddress,
              billingAddress2: isServiceSameAsBill
                ? values.serviceAddress2
                : values.billingAddress2,
              billingCountry: isServiceSameAsBill ? values.serviceCountry : values.billingCountry,
              billingState: isServiceSameAsBill ? values.serviceState : values.billingState,
              billingCity: isServiceSameAsBill ? values.serviceCity : values.billingCity,
              billingZipCode: isServiceSameAsBill ? values.serviceZipCode : values.billingZipCode,
              languageId: values.languageId,
              ...(values.benefitProgramId && {
                benefitProgramId: values.benefitProgramId,
              }),
              productId: values.productName,
              id: values.id,
              documentDelivery: values.documentDelivery,
              customerEnrollments: handleCustomerUanEdit(),
              customerTpvType: values.tpvType,
              customerServiceBillLatitude: latlong?.lat,
              customerServiceBillLongitude: latlong?.lng,
              billUrls: values.customerBillUrl.length > 0 ? values.customerBillUrl : [],
              phoneType: formik.values.linetype,
              dateOfBirth: values.dateOfBirth,
            },
          },
        })
        handleCloseModal()
      }
    },
  })
  const [languages, setLanguages] = useState<any>()
  const [benefitProgram, setBenefitProgram] = useState<any>()

  //to get the language of the product
  const [getProductLanguage] = useLazyQuery(GET_PRODUCT_LANAGUAGE_BENEFIT_PROGRAM, {
    fetchPolicy: 'network-only',
    variables: {
      productId: formik.getFieldMeta('productName').value,
      tpvId: Boolean(formik.values.tpvId) ? formik.values.tpvId : null,
    },

    onCompleted: (data) => {
      setBenefitProgram(data?.getProductLanguagesAndBenefitPrograms)
      setLanguages(data?.getProductLanguagesAndBenefitPrograms)
    },
    onError: (err) => {
      setLanguages([])
    },
  })
  //to get the product based on the filters
  // const [getProductInfo, {loading: productsloading}] = useLazyQuery(GET_PRODUCT_INFO, {
  //   fetchPolicy: 'network-only',
  //   variables: {
  //     customerProductInputs: {
  //       commodityId: formik.getFieldMeta('commodityId').value,
  //       contractTypeId: formik.getFieldMeta('contractTypeId').value,
  //       utilityId: formik.getFieldMeta('utilityId').value,
  //       brandTypeId: formik.getFieldMeta('brandsId').value,
  //       customerTypeId: formik.getFieldMeta('customerTypeId').value,
  //     },
  //     isMixMatch: formik.getFieldMeta('isMixMatch').value,
  //   },
  //   onCompleted: (productData) => {
  //     setProducts(productData?.getCustomerProductInfo)
  //   },
  // })

  const [customerType, setCustomerType] = useState<any>()
  const [allUnits, setAllUnits] = useState<any>()
  const [allBrand, setAllBrand] = useState<any>()

  const [getProductSetupInfo, {loading}] = useLazyQuery(GET_CUSTOMER_ENROLLMENT_DATA, {
    fetchPolicy: 'network-only',

    onCompleted: (productData) => {
      setAllBrand(
        productData.getCustomerEnrollmentData.brands.map((types: any) => ({
          id: types.id,
          value: types.name,
        }))
      )
      setAllUnits(
        productData.getCustomerEnrollmentData.unitTypes.map((types: any) => ({
          id: types.id,
          value: types.name,
        }))
      )
    },
  })
  const [getProductInfo, {loading: productsloading}] = useLazyQuery(GET_AGENT_PRODUCTS_AND_FILTER, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        isMixMatch: formik.values.isMixMatch,
        productFilters: {
          commodityId: formik.getFieldMeta('commodityId').value
            ? formik.getFieldMeta('commodityId').value
            : null,
          contractTypeId: formik.getFieldMeta('contractTypeId').value
            ? formik.getFieldMeta('contractTypeId').value
            : null,
          utilityId: formik.getFieldMeta('utilityId').value
            ? formik.getFieldMeta('utilityId').value
            : null,
          brandTypeId: formik.getFieldMeta('brandsId').value
            ? formik.getFieldMeta('brandsId').value
            : null,
          customerTypeId: formik.getFieldMeta('customerTypeId').value
            ? formik.getFieldMeta('customerTypeId').value
            : null,
        },
      },
    },
    onCompleted: (productData) => {
      setProducts(productData?.getAgentProductsAndFilter?.products)
      setCustomerType(
        productData.getAgentProductsAndFilter.productFilters.customerTypes.map((types: any) => ({
          id: types.id,
          value: types.name,
        }))
      )
    },
  })

  useEffect(() => {
    const guanValidation = productDetails?.gutility?.uanValidation
    const euanValidation = productDetails?.utility?.uanValidation
    const gregexValidation = productDetails?.gutility?.regexValidation
    const gregexValidationMessage = productDetails?.gutility?.regexValidationMessage
    const eregexValidation = productDetails?.utility?.regexValidation
    const eregexValidationMessage = productDetails?.utility?.regexValidationMessage
    const emeterRegexValidation = productDetails?.utility?.meterRegexValidation
    const emeterRegexValidationMessage = productDetails?.utility?.meterRegexValidationMessage
    const gmeterRegexValidation = productDetails?.gutility?.meterRegexValidation
    const gmeterRegexValidationMessage = productDetails?.gutility?.meterRegexValidationMessage
    const meterId =
      emeterRegexValidation &&
      Yup.string()
        .required('E_Meter Id is required')
        .matches(emeterRegexValidation, emeterRegexValidationMessage)
    const gmeterId =
      gmeterRegexValidation &&
      Yup.string()
        .required('G_Meter Id is required')
        .matches(gmeterRegexValidation, gmeterRegexValidationMessage)
    const utilityValidation = eregexValidation
      ? Yup.string()
          .required('E_UAN is required')
          .matches(eregexValidation, eregexValidationMessage)
      : Boolean(euanValidation)
      ? Yup.string()
          .required('E_UAN is required')
          .matches(/^\S*$/, 'Spaces not allowed')
          .length(euanValidation, `E_UAN should be ${String(euanValidation)} characters`)
      : Yup.string()
          .required('E_UAN is required')
          .matches(/^\S*$/, 'Spaces not allowed')
          .min(3, "E_UAN  shouldn't be less than 3 characters")
          .max(30, "E_UAN  shouldn't exceed less than 30 characters")
    const gutilityValidation = gregexValidation
      ? Yup.string()
          .required('G_UAN is required')
          .matches(gregexValidation, gregexValidationMessage)
      : Boolean(guanValidation)
      ? Yup.string()
          .required('G_UAN is required')
          .matches(/^\S*$/, 'Spaces not allowed')
          .length(guanValidation, `G_UAN should be ${String(guanValidation)} characters`)
      : Yup.string()
          .required('G_UAN is required')
          .matches(/^\S*$/, 'Spaces not allowed')
          .min(3, "G_UAN  shouldn't be less than 3 characters")
          .max(30, `G_UAN shouldn't exceed 30 characters`)
    if (formik.values.selectedProductCommodity === 'Electric') {
      delete validationSchema.gutilityAccountNumber
      setValidationSchema({
        ...validationSchema,
        utilityAccountNumber: utilityValidation,
        ...(productDetails?.isDynamicProduct && electricValidations),
        ...(isEnableContractStartDate && {
          contractStartDate: Yup.string().required('E_Contract Start Date is required'),
        }),
        ...(isUtilityMeterNumberRequired && {meterId: meterId}),
      })
    } else if (formik.values.selectedProductCommodity === 'Gas') {
      delete validationSchema.utilityAccountNumber
      setValidationSchema({
        ...validationSchema,
        gutilityAccountNumber: gutilityValidation,
        ...(productDetails?.isDynamicProduct && gasValidations),
        ...(isEnableContractStartDate && {
          gcontractStartDate: Yup.string().required('G_Contract Start Date  is required'),
        }),
        ...(isUtilityMeterNumberRequired && {gmeterId: gmeterId}),
      })
    } else if (formik.values.selectedProductCommodity === 'Dual' || formik.values.isMixMatch) {
      setValidationSchema({
        ...validationSchema,
        utilityAccountNumber: utilityValidation,
        gutilityAccountNumber: gutilityValidation,
        ...((formik.values.eisdynamic || productDetails?.isDynamicProduct) && electricValidations),
        ...((formik.values.gisdynamic || productDetails?.isDynamicProduct) && gasValidations),
        ...(isUtilityMeterNumberRequired && {meterId: meterId, gmeterId: gmeterId}),
        ...(isEnableContractStartDate && {
          contractStartDate: Yup.string().required('E_Contract Start Date is required'),
          gcontractStartDate: Yup.string().required('G_Contract Start Date is required'),
        }),
      })
    }
  }, [
    formik.values.selectedProductCommodity,
    formik.values.productName,
    formik.values.gasMixMatchProductId,
    limitValue,
  ])
  const bussinessRef = useRef() as React.MutableRefObject<HTMLInputElement>
  const documentRef = useRef() as React.MutableRefObject<HTMLInputElement>
  const [createCustomerEnrollment] = useMutation(CREATE_CUSTOMER_ENROLLMENT, {
    onCompleted: (createCustomerData) => {
      setSubmitting(false)
      setUploadedFiles([])
      if (createCustomerData.createCustomerEnrollment.customerId) {
        const options: any = {
          width: 550,
          showConfirmButton: false,
          heightAuto: false,
          customClass: {
            popup: 'card card-custom',
            htmlContainer: 'card htmlContainer',
          },
          html: (
            <>
              <div className='h-400px'>
                <div className='d-flex alert alert-success rounded p-6 mt-5 mb-5'>
                  <span className='svg-icon svg-icon-2tx svg-icon-warning me-4'>
                    <img
                      src={successIcon}
                      alt='success'
                      className='mh-50px'
                      width={42}
                      height={42}
                    />
                  </span>
                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <h4 className='text-success fw-bolder'>
                        New Enrollment successfully created
                      </h4>
                    </div>
                  </div>
                </div>
                <div className='mt-5 mb-5'>
                  <Stack gap={5}>
                    <div className='fw-bold fs-2 text-start'>TPV Details</div>
                    <Stack direction='horizontal'>
                      <div className='text-gray-500'>Customer Name</div>
                      <div className='text-dark ms-auto'>
                        {`${createCustomerData.createCustomerEnrollment?.customerFirstName} ${createCustomerData.createCustomerEnrollment?.customerLastName}`}
                      </div>
                    </Stack>
                    <Stack direction='horizontal'>
                      <div className='text-gray-500'>Customer Primary Phone Number</div>
                      <div className='text-dark ms-auto '>
                        {Boolean(createCustomerData.createCustomerEnrollment.customerPhoneNumber)
                          ? renderPhoneNumber(
                              createCustomerData.createCustomerEnrollment.customerPhoneNumber
                            )
                          : '-'}
                      </div>
                    </Stack>
                    <Stack direction='horizontal'>
                      <div className='text-gray-500'>Customer Transfer Phone Number</div>
                      <div className='text-dark ms-auto '>
                        {Boolean(createCustomerData?.createCustomerEnrollment?.transferPhoneNumber)
                          ? renderPhoneNumber(
                              createCustomerData.createCustomerEnrollment.transferPhoneNumber
                            )
                          : '-'}
                      </div>
                    </Stack>
                    <Stack direction='horizontal'>
                      <div className='text-gray-500'>Customer Pincode</div>
                      <div className='text-dark ms-auto '>
                        {createCustomerData.createCustomerEnrollment.pincode}
                      </div>
                    </Stack>
                  </Stack>
                </div>
                <div className='d-flex flex-stack pt-10 flex-row-reverse mt-5'>
                  <div
                    className='btn btn-light-primary'
                    onClick={() => {
                      MySwal.close()
                    }}
                  >
                    Close
                  </div>
                </div>
              </div>
            </>
          ),
        }
        MySwal.fire(options)
      }
      refetchList()
      handleCloseModal()
      getSalesAdminDashboardData()
    },
    onError: ({message}) => {
      setSubmitting(false)
      MySwal.fire({
        icon: 'error',
        title: message,
      })
    },
  })
  const [deleteS3File] = useLazyQuery(S3_FILE_DELETE, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  const [billImageToDeleteUrls, setBillImageToDeleteUrls] = useState<Array<string>>([])
  const [updateCustomerEnrollment] = useMutation(UPDATE_CUSTOMER_ENROLLMENT, {
    onCompleted: (updateCustomerData) => {
      setSubmitting(false)
      if (updateCustomerData.updateCustomerEnrollment.customerId) {
        const options: any = {
          width: 550,
          showConfirmButton: false,
          heightAuto: false,
          customClass: {
            popup: 'card card-custom',
            htmlContainer: 'card htmlContainer',
          },
          html: (
            <>
              <div className=''>
                <div className='d-flex alert alert-success rounded p-6 mt-5 mb-5'>
                  <span className='svg-icon svg-icon-2tx svg-icon-warning me-4'>
                    <img
                      src={successIcon}
                      alt='success'
                      className='mh-50px'
                      width={42}
                      height={42}
                    />
                  </span>
                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <h4 className='text-success fw-bolder'>Customer sucessfully Updated</h4>
                    </div>
                  </div>
                </div>
                {modalConfig.mode === 'create' && (
                  <div className='mt-5 mb-5'>
                    <Stack gap={5}>
                      <div className='fw-bold fs-2 text-start'>TPV Details</div>
                      <Stack direction='horizontal'>
                        <div className='text-gray-500'>Customer Name</div>
                        <div className='text-dark ms-auto'>
                          {updateCustomerData.updateCustomerEnrollment.customerFirstName}
                        </div>
                      </Stack>
                      <Stack direction='horizontal'>
                        <div className='text-gray-500'>Customer Phone Number</div>
                        <div className='text-dark ms-auto '>
                          {updateCustomerData.updateCustomerEnrollment.customerPhoneNumber}
                        </div>
                      </Stack>
                      <Stack direction='horizontal'>
                        <div className='text-gray-500'>Customer Transfer Phone Number</div>
                        <div className='text-dark ms-auto '>
                          {updateCustomerData.updateCustomerEnrollment.transferPhoneNumber}
                        </div>
                      </Stack>
                      <Stack direction='horizontal'>
                        <div className='text-gray-500'>Customer Pincode</div>
                        <div className='text-dark ms-auto '>
                          {updateCustomerData.updateCustomerEnrollment.pincode}
                        </div>
                      </Stack>
                    </Stack>
                  </div>
                )}

                <div className='d-flex flex-stack pt-10 flex-row-reverse mt-5'>
                  <div
                    className='btn btn-light-primary'
                    onClick={() => {
                      MySwal.close()
                    }}
                  >
                    Close
                  </div>
                </div>
              </div>
            </>
          ),
        }
        MySwal.fire(options)
      }
      if (billImageToDeleteUrls.length !== 0) {
        billImageToDeleteUrls.forEach((url) => {
          deleteS3File({
            variables: {
              bucketName: process.env.REACT_APP_BUCKET_NAME,
              key: url,
            },
          })
        })
      }
      refetchList()
      handleClose()
      getSalesAdminDashboardData()
    },
    onError: (err) => {
      setSubmitting(false)
      MySwal.fire({
        icon: 'error',
        title: err.message,
      })
    },
  })
  const handleCloseModal = () => {
    formik.setValues(defaultAgentEnrollment)
    formik.setTouched(fieldTouched(false))
    setValidationSchema({})
    setProductDetails({})
    setSendContract(false)
    setSendContractEmail(false)
    setCurrentScreen(1)
    setBillImageToDeleteUrls([])
    setIsExistingCustomer(false)
    handleClose()
    trackIdRef.current = ''
  }
  //deletebillimage

  const handleDeleteImage = (url: string, name: string) => {
    if (url) {
      areYouSurePrompt(
        'Are you sure to delete?',
        () => {
          formik.setFieldValue(
            'customerBillUrl',
            formik.values.customerBillUrl.filter((billUrl) => !url.includes(billUrl))
          )
          setBillImageToDeleteUrls((prev) => [...prev, url])
          setUploadedFiles(uploadedFiles.filter((item) => item.name != name))
        },
        () => {},
        'Yes,delete',
        'No!'
      )
    }
  }
  const handleCheckOptin = () => {
    checkPhonenumberOptin({
      variables: {
        phoneNumber: formik.values.customerPrimaryPhoneNumber,
      },
    })
  }
  //
  const triggerOptinAlert = () => {
    showAlertWithCallbackOnConfirmation(
      `Customer is not opted-in.To opt-in please ask the customer to send "start" to ${renderPhoneNumber(
        clientDialInNumber
      )}`,
      'info',
      handleCheckOptin
    )
  }
  //responsive
  const ismobile = useMediaQuery({query: '(max-width: 600px)'})
  const isDesktopLg = useMediaQuery({query: '(max-width: 1300px)'})
  const isDesktopXl = useMediaQuery({query: '(min-width: 1305px)'})
  const handleResponsiveWidth = () => {
    if (isDesktopXl) {
      return '500px'
    } else if (isDesktopLg) {
      return '400px'
    } else if (ismobile) {
      return '500px'
    }
  }

  //symmetry API check
  const [checkExistingCustomerForSymmetry] = useLazyQuery(CHECK_EXISTING_CUSTOMERR_FOR_SYMMETRY, {
    onCompleted: (data) => {
      if (data.checkExistingSymmetryCustomer.isExistingCustomer) {
        alert('Customer Already Exists', 'error')
        formik.setFieldValue('utilityAccountNumber', '')
        formik.setFieldValue('gUtilityAccountNumber', '')
      }
    },
  })
  const [checkExistingCustomerForPtm] = useLazyQuery(CHECK_EXISTING_CUSTOMERR_FOR_PTM, {
    onCompleted: (data) => {
      if (data.checkExistingPTMCustomer) {
        areYouSurePrompt(
          'Utility Account Number already exists!',

          () => {
            setIsExistingCustomer(true)
          },
          () => {
            formik.setValues({
              ...formik.values,
              utilityAccountNumber: '',
            })
          },
          undefined,
          'Go Back',
          'Agent, this Utility Account Number already exists and cannot be enrolled. Check if the Customer would like to submit another Utility Account Number instead'
        )
      }
    },
  })

  // const [linetype,setLineType]=useState()
  const [checkPhoneLineType] = useLazyQuery(GET_LINE_TYPE_INTELLIGENCE, {
    onCompleted: (data) => {
      // setLineType(data.getLineTypeIntelligence.type)
      formik.setFieldValue('linetype', data.getLineTypeIntelligence.type)
      // MySwal.fire({
      //   title: `Phone Line Type : ${data.getLineTypeIntelligence.type === null ? 'No type found' : data.getLineTypeIntelligence.type}`,
      //   icon: 'success',
      // })
    },
  })

  const [getClientAllowedComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setImageUploadRequired(data?.getClientAllowedComponents.includes('imageUploadRequired'))
      setImageTextError(data?.getClientAllowedComponents.includes('changeBillImageText'))
      setIsSolarPRoduct(data?.getClientAllowedComponents.includes('solarProductSetup'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getClientAllowedComponents()
    getProductSetupInfo()
  }, [])

  console.log(formik, '>>>>>formik')
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={`modal-dialog modal-dialog-scrollable modal-xl modal-fullscreen `}
      show={show}
      onHide={() => handleCloseModal()}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        {modalConfig.mode === 'edit' ? (
          <h2>{`${formik.values.customerFirstName} ${formik.values.customerLastName}`}</h2>
        ) : (
          <h2>Enroll New Customer</h2>
        )}
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => {
            handleCloseModal()
            formik.setTouched(fieldTouched(false))
            setUploadedFiles([])
            setFileUploadError('')
          }}
        >
          <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              opacity='0.5'
              d='M7.00002 5.76278L5.76282 6.99998L0.256396 12.5059C-0.0854139 12.8476 -0.0854139
                13.4018 0.256396 13.7436C0.598179 14.0854 1.15236 14.0854 1.49417 13.7436L7.00002
                8.23718L8.23722 6.99998L13.7436 1.49413C14.0855 1.15235 14.0854 0.598168 13.7436
                0.256358C13.4019 -0.0854526 12.8477 -0.0854526 12.5059 0.256358L7.00002 5.76278Z'
              fill='#7E8299'
            ></path>

            <path
              d='M6.99998 5.76278L8.23718 6.99998L13.7436 12.5059C14.0854 12.8476 14.0854 13.4018
                13.7436 13.7436C13.4018 14.0854 12.8476 14.0854 12.5058 13.7436L6.99998 8.23718L5.76278
                6.99998L0.256358 1.49413C-0.0854526 1.15235 -0.0854252 0.598168 0.256358 0.256358C0.598141
                -0.0854526 1.15232 -0.0854526 1.49413 0.256358L6.99998 5.76278Z'
              fill='#7E8299'
            ></path>
          </svg>
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/* <button
          onClick={() =>
            sendSMSHandler()
          }
        >
          Trackupload
        </button> */}
        <Row>
          <Col lg='12' xl='4'>
            {formik?.values?.customerBillUrl?.length > 0 || uploadedFiles.length > 0 ? (
              <>
                <Viewer
                  urls={formik?.values?.customerBillUrl}
                  files={uploadedFiles}
                  previewSettings={GLOBAL_CONSTANTS.previewSettings}
                  className={`w-${handleResponsiveWidth()} m-auto`}
                  isDeletable={true}
                  deleteHandler={handleDeleteImage}
                />
              </>
            ) : (
              <>
                <div
                  className={` h-250px h-md-${
                    GLOBAL_CONSTANTS.previewSettings.height
                  }px mx-auto my-0 d-flex justify-content-center align-items-center mw-${handleResponsiveWidth()}`}
                  style={{backgroundColor: '#f4f4f4'}}
                >
                  {uploadedFiles.length > 0 ? (
                    <h3 className='text-muted'>loading...</h3>
                  ) : (
                    <h3 className='text-muted'>Customer bill is not uploaded</h3>
                  )}
                </div>
              </>
            )}
            {customerBillImage ? (
              featureFlags?.getClientFeatureFlags?.isBillImagesRequired &&
              enableCustomerBillImage ? (
                <div className='mx-auto my-5 d-flex flex-column justify-content-center align-items-center w-400px'>
                  <UploadFiles
                    isMultiple={true}
                    setUploadedFiles={setUploadedFiles}
                    fileTypes='image/*,application/pdf'
                    labelText={
                      imageTextError
                        ? 'Agent Photo Required. Bill Images should be added after Selfie'
                        : forceCameraOpen
                        ? 'Please upload image(s)'
                        : 'Please upload image(s) or a PDF'
                    }
                    buttontext={
                      uploadedFiles.length !== 0 || formik?.values?.customerBillUrl?.length > 0
                        ? 'Add more'
                        : 'Select files to upload'
                    }
                    setFileUploadError={setFileUploadError}
                    FileUploaderror={FileUploaderror}
                    forceCameraOpen={forceCameraOpen}
                  />
                </div>
              ) : null
            ) : (
              featureFlags?.getClientFeatureFlags?.isBillImagesRequired && (
                <div className='mx-auto my-5 d-flex flex-column justify-content-center align-items-center w-400px'>
                  <UploadFiles
                    isMultiple={true}
                    setUploadedFiles={setUploadedFiles}
                    fileTypes='image/*,application/pdf'
                    labelText={
                      imageTextError
                        ? 'Agent Photo Required. Bill Images should be added after Selfie'
                        : forceCameraOpen
                        ? 'Please upload image(s)'
                        : 'Please upload image(s) or a PDF'
                    }
                    buttontext={
                      uploadedFiles.length !== 0 || formik?.values?.customerBillUrl?.length > 0
                        ? 'Add more'
                        : 'Select files to upload'
                    }
                    setFileUploadError={setFileUploadError}
                    FileUploaderror={FileUploaderror}
                    forceCameraOpen={forceCameraOpen}
                  />
                </div>
              )
            )}
          </Col>

          <Col lg='12' xl='8'>
            <div
              ref={stepperRef}
              className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
              id='kt_modal_create_app_stepper'
            >
              <div className='d-flex mb-3 w-100 w-xl-300px'>
                <div className='stepper-nav align-items-baseline flex-row flex-xl-column ps-lg-10'>
                  <div
                    className={`stepper-item ${currentScreen > 1 ? 'completed' : ''} ${
                      currentScreen === 1 ? 'show-stepper current' : 'hide-stepper'
                    }`}
                    data-kt-stepper-element='nav'
                  >
                    <div className='stepper-wrapper'>
                      <div className='stepper-icon w-40px h-40px'>
                        <i className='stepper-check fas fa-check'></i>
                        <span className='stepper-number'>1</span>
                      </div>

                      <div className='stepper-label'>
                        <h3 className='fs-4'>Account Info</h3>

                        <div className='stepper-desc'>Provide your account information</div>
                      </div>
                    </div>

                    <div className='stepper-line h-40px d-none d-xl-block'></div>
                  </div>

                  <div
                    className={`stepper-item ${currentScreen > 2 ? 'completed' : ''} ${
                      currentScreen === 2 ? 'show-stepper current' : 'hide-stepper'
                    }`}
                    data-kt-stepper-element='nav'
                  >
                    <div className='stepper-wrapper'>
                      <div className='stepper-icon w-40px h-40px'>
                        <i className='stepper-check fas fa-check'></i>
                        <span className='stepper-number'>2</span>
                      </div>

                      <div className='stepper-label'>
                        <h3 className='fs-4'>Customer Info</h3>
                        <div className='stepper-desc'>Provide your customer information</div>
                      </div>
                    </div>

                    <div className='stepper-line h-40px d-none d-xl-block'></div>
                  </div>
                  {/* <div className='w-40px mx-2 stepper-line-border d-block d-xl-none'></div> */}
                  <div
                    className={`stepper-item ${currentScreen > 3 ? 'completed' : ''} ${
                      currentScreen === 3 ? 'show-stepper current' : 'hide-stepper'
                    }`}
                    data-kt-stepper-element='nav'
                  >
                    <div className='stepper-wrapper'>
                      <div className='stepper-icon w-40px h-40px'>
                        <i className='stepper-check fas fa-check'></i>
                        <span className='stepper-number'>3</span>
                      </div>

                      <div className='stepper-label'>
                        <h3 className='fs-4'>Product Info</h3>

                        <div className='stepper-desc'>Provide your product information</div>
                      </div>
                    </div>
                    {modalConfig.mode === 'edit' && <div className='stepper-line h-40px'></div>}
                  </div>
                  {modalConfig.mode === 'edit' && (
                    <div
                      className={`stepper-item ${currentScreen > 4 ? 'completed' : ''} ${
                        currentScreen === 4 ? 'show-stepper current' : 'hide-stepper'
                      }`}
                      data-kt-stepper-element='nav'
                    >
                      <div className='stepper-wrapper'>
                        <div className='stepper-icon w-40px h-40px'>
                          <i className='stepper-check fas fa-check'></i>
                          <span className='stepper-number'>4</span>
                        </div>

                        <div className='stepper-label'>
                          <h3 className='stepper-title'>TPV Details</h3>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='flex-row-fluid'>
                <AccountInfo
                  isSolarProduct={isSolarProduct}
                  mode={modalConfig.mode}
                  hasFieldError={hasFieldError}
                  isExistingCustomer={isExistingCustomer}
                  setIsExistingCustomer={setIsExistingCustomer}
                  formik={formik}
                  isCommercialCustomer={isCommercialCustomer}
                  getCustomerByPhoneNumber={getCustomerByPhoneNumber}
                  setSearchText={setSearchText}
                  customerData={customerData}
                  customer={customer}
                  searchText={searchText}
                  setIsCommercialCustomer={setIsCommercialCustomer}
                  setIsServiceSameAsBill={setIsServiceSameAsBill}
                  primaryPhoneNumberValidation={primaryPhoneValidation}
                  emailAlreadyExists={emailAlreadyExists}
                  sendBillImageSMS={sendSMSHandler}
                  featureFlags={featureFlags}
                  isOptedIn={isOptedIn}
                  setIsOptedIn={setIsOptedIn}
                  documentRef={documentRef}
                  documentDelivery={documentDelivery}
                  sendBillImageEmail={sendBillImageEmailHandler}
                  checkPhonenumberOptin={checkPhonenumberOptin}
                  triggerOptinAlert={triggerOptinAlert}
                  disableExistingCustomerEnrollment={disableExistingCustomerEnrollment}
                  // enableZipCodeInUtility={enableZipCodeInUtility}
                  checkPhoneLineType={checkPhoneLineType}
                  setSendContract={setSendContract}
                />
                <CustomerInfo
                  handleClose={handleClose}
                  data={data}
                  formik={formik}
                  updateData={updateData}
                  hasError={hasError}
                  hasFieldError={hasFieldError}
                  isCommercialCustomer={isCommercialCustomer}
                  setIsCommercialCustomer={setIsCommercialCustomer}
                  isExistingCustomer={isExistingCustomer}
                  SetIsExistingCustomer={setIsExistingCustomer}
                  defaultAgentEnrollment={defaultAgentEnrollment}
                  mode={modalConfig.mode}
                  searchText={searchText}
                  setSearchText={setSearchText}
                  customer={customer}
                  setCustomer={setCustomer}
                  getCustomerByPhoneNumber={getCustomerByPhoneNumber}
                  customerLoading={customerLoading}
                  customerData={customerData}
                  isServiceSameAsBill={isServiceSameAsBill}
                  setIsServiceSameAsBill={setIsServiceSameAsBill}
                  bussinessRef={bussinessRef}
                  getcustomerByIdData={getcustomerByIdData}
                  featureFlags={featureFlags}
                  setSendContract={setSendContract}
                  sendContract={sendContract}
                  sendContractEmail={sendContractEmail}
                  setSendContractEmail={setSendContractEmail}
                  customerFeatureFlags={customerFeatureFlags}
                  isOptedIn={isOptedIn}
                  triggerOptinAlert={triggerOptinAlert}
                  setDocumentDelivery={setDocumentDelivery}
                  setUtilities={setUtilities}
                  customerType={customerType}
                  setCustomerType={setCustomerType}
                  sendContractMessgae={sendContractMessgae}
                  setSendContractMessage={setSendContractMessage}
                  isSolarProduct={isSolarProduct}
                />
                <ProductInfo
                  benefitProgram={benefitProgram}
                  show={show}
                  data={data}
                  formik={formik}
                  updateData={updateData}
                  hasError={hasError}
                  hasFieldError={hasFieldError}
                  method={modalConfig.mode}
                  getProductInfo={getProductInfo}
                  products={products}
                  setProducts={setProducts}
                  Yup={Yup}
                  validationSchema={validationSchema}
                  setValidationSchema={setValidationSchema}
                  productDetails={productDetails}
                  setProductDetails={setProductDetails}
                  UANValidation={UANValidation}
                  tpvMethods={tpvMethods}
                  isOptedIn={isOptedIn}
                  sendContract={sendContract}
                  sendContractEmail={sendContractEmail}
                  triggerOptinAlert={triggerOptinAlert}
                  checkPhonenumberOptin={checkPhonenumberOptin}
                  isMixmatch={isMixmatch}
                  isEnableContractStartDate={isEnableContractStartDate}
                  isUtilityMeterNumberRequired={isUtilityMeterNumberRequired}
                  checkExistingCustomerFromAPI={featureFlags?.getClientFeatureFlags?.enableApiCheck}
                  checkExistingCustomerForSymmetry={checkExistingCustomerForSymmetry}
                  checkExistingCustomerForPtm={checkExistingCustomerForPtm}
                  languages={languages}
                  getProductLanguage={getProductLanguage}
                  utilities={utilities}
                  setUtilities={setUtilities}
                  setLimitValue={setLimitValue}
                  editmode={modalConfig.mode === 'edit'}
                  isSolarProduct={isSolarProduct}
                  allUnits={allUnits}
                  allBrand={allBrand}
                />
                <TPVStatus formik={formik} />
                {(sendContract || sendContractEmail) && (
                  <AgentGeolocation setAgentCoords={setAgentCoords} />
                )}

                {/*begin::Actions */}
                <div className='d-flex flex-stack pt-10'>
                  <div className='me-2'>
                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                      onClick={prevStep}
                    >
                      <span className='me-1'>
                        <SVG src={Arrow} className='mh-50px' />
                      </span>
                      <span>Back</span>
                    </button>
                  </div>
                  <div>
                    <button
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='submit'
                      disabled={
                        (formik.values.isMixMatch
                          ? !Boolean(formik.getFieldMeta('electricMixMatchProductId').value)
                          : !Boolean(formik.getFieldMeta('productName').value)) ||
                        !Boolean(formik.values.languageId) ||
                        !Boolean(formik.values.tpvType) ||
                        validateLoading
                      }
                      onClick={handleClick}
                    >
                      {submitting ? 'Submitting' : 'Submit'}
                      {submitting && (
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      )}
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                      />
                    </button>

                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='next'
                      onClick={nextStep}
                      disabled={validateLoading || productsloading}
                    >
                      Continue
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-1 me-0'
                      />
                    </button>
                  </div>
                </div>
                {/*end::Actions */}

                {/*end::Form */}
              </div>
              {/*end::Content */}
            </div>
          </Col>
        </Row>

        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export default CreateAgentModal
